import { Globe, Smartphone, Server, Gamepad2 } from 'lucide-react';

export const SERVICES = [
  {
    slug: 'web-development',
    title: 'Web Development',
    short: 'Responsive websites, SaaS platforms, dashboards, and web applications.',
    icon: Globe,
    desc: 'We design and develop high-performance websites, SaaS platforms, admin dashboards, and complex web applications. From marketing sites to full-stack products, built with React, Next.js, Python, and modern cloud infrastructure.',
    tech: ['React', 'Next.js', 'Node.js', 'Python', 'FastAPI', 'PostgreSQL', 'MongoDB', 'AWS', 'Vercel'],
  },
  {
    slug: 'mobile-apps',
    title: 'Mobile Apps',
    short: 'iOS & Android apps, native and cross-platform with React Native & Flutter.',
    icon: Smartphone,
    desc: 'Native and cross-platform mobile applications for iOS and Android. From consumer apps to enterprise mobility solutions, designed for performance, offline support, and seamless UX.',
    tech: ['React Native', 'Flutter', 'Swift', 'Kotlin', 'Firebase', 'REST APIs', 'Push Notifications'],
  },
  {
    slug: 'enterprise',
    title: 'Enterprise Software',
    short: 'ERP, CRM, workflow automation, and internal tools for large organizations.',
    icon: Server,
    desc: 'Custom enterprise applications including ERP systems, CRM platforms, workflow automation, inventory management, and internal tools. Built for security, scalability, and integration with existing systems.',
    tech: ['Python', 'Java', 'Microservices', 'Docker', 'Kubernetes', 'PostgreSQL', 'Redis', 'SSO/LDAP'],
  },
  {
    slug: 'gaming',
    title: 'Gaming & Game Apps',
    short: 'Casual games, esports platforms, real-time multiplayer, and game-tech tools.',
    icon: Gamepad2,
    desc: 'Game development from casual mobile games to esports platforms and real-time multiplayer experiences. We also build game-tech infrastructure, tournaments, leaderboards, matchmaking, and creator tools.',
    tech: ['Unity', 'Unreal Engine', 'WebGL', 'Socket.io', 'Game Servers', 'Real-time Systems', 'AI/ML'],
  },
];

export const CLIENTS = [
  { name: 'Newswise', url: 'https://www.newswise.com/', desc: 'Global news distribution platform' },
  { name: 'Hydro Cleansing', url: 'https://hydro-cleansing.com/', desc: 'UK drainage & waste management' },
  { name: 'Digizion', url: 'https://teacher.digizion.in/', desc: 'EdTech teacher platform' },
  { name: 'Zutron', url: 'https://app.zutron.in/', desc: 'SaaS application platform' },
  { name: 'Air1CA', url: 'https://air1ca.com/', desc: 'Aviation services platform' },
  { name: 'Mapathink', url: 'https://www.mapathink.com/', desc: 'Geospatial intelligence' },
  { name: 'WeAre1 Academy', url: 'https://weare1.academy/', desc: 'Online learning academy' },
  { name: 'IraSoles', url: 'https://irasoles.com/', desc: 'D2C footwear brand' },
  { name: 'Kaashi Wellness', url: 'https://www.kaashiwellness.com/', desc: 'Health & wellness platform' },
  { name: 'TagHome', url: 'https://www.taghome.in/', desc: 'Real estate platform' },
  { name: 'Expo Real Germany', url: '#', desc: 'International real estate expo (2025)' },
  { name: 'TOGG Turkey', url: '#', desc: 'Turkish automotive tech (2025 Q4)' },
  { name: 'CarsbikesPrices', url: 'https://carsbikesprices.com', desc: 'Vehicle comparison platform' },
  { name: 'MetroMandi', url: 'https://metromandi.com', desc: 'Deals & coupons platform' },
  { name: 'YourMoneyWise', url: 'https://yourmoneywise.net', desc: 'Finance education platform' },
  { name: 'GamesNFans', url: 'https://www.gamesnfans.tv', desc: 'Esports & gaming news' },
  { name: 'DGTG', url: 'https://www.dgtg.in', desc: 'Digital growth agency' },
  { name: 'Vikasifications', url: 'https://www.vikasifications.com', desc: 'Personal brand platform' },
  { name: 'AURALIS', url: '#', desc: 'AI-powered platform' },
];
